const removeBrokenImg = (imgEl) => {
  const imgWrap = imgEl.closest(".models-item");
  imgWrap.remove();
};

modelsSlider = new Swiper(".models-slider", {
  slidesPerView: 4,
  navigation: {
    nextEl: ".models-button-next",
    prevEl: ".models-button-prev",
  },
  breakpoints: {
    280: {
      slidesPerView: 1,
    },
    560: {
      slidesPerView: 2,
    },
    768: {
      slidesPerView: 3,
    },
    1000: {
      slidesPerView: 4,
    },
    1200: {
      slidesPerView: 5,
    },
  },
});

// Custom JS for Lightbox (see my size section)
document.querySelectorAll(".models-item img").forEach((img) => {
  img.addEventListener("click", () => {
    const lightboxWrap = document.querySelector(".lightbox-container");
    const lightboxMatchedImg = lightboxWrap.querySelector(
      `img[data-index-img="${img.dataset.indexImg}"]`
    );
    const lightboxMatchedImgWrap = lightboxMatchedImg.closest("article");
    lightboxMatchedImgWrap.classList.remove("hide");
    lightboxMatchedImg.src = lightboxMatchedImg.dataset.src;
    lightboxWrap.classList.add("show-lightbox");
  });
});

document
  .querySelectorAll(".lightbox-close-btn, .lightbox-container.show-lightbox")
  .forEach((el) => {
    el.addEventListener("click", () => {
      const lightboxWrap = document.querySelector(".lightbox-container");
      lightboxWrap.classList.remove("show-lightbox");
      document.querySelectorAll(".models-item-lightbox").forEach((item) => {
        item.classList.add("hide");
      });
    });
  });

// Models sizes slider
document.addEventListener(
  "DOMContentLoaded",
  function () {
    // Load Quickview's JS for 'Style it with' products (JS variable in theme.liquid)
    document.dispatchEvent(pdpStyleLoaded);
  },
  false
);

// Size guide on PDP
const sizeGuideTrigger = document.querySelector(".size-guide-btn");
const sizeGuide = document.querySelector(".size-guide");
const sizeGuideClose = document.querySelector(".size-guide__close");

sizeGuideTrigger.addEventListener("click", function () {
  sizeGuide.classList.add("show-modal");
  sizeGuideOverlay.classList.add("show-overlay");

  // Show first video/image when opening pop up
  const sizesCard = document.querySelector(`.size-guide__sizes-card.active`);
  renderSizesMedia(sizesCard);

  // Render video in size guide
  // const video = document.querySelector('.size-guide__video video')
  const videos = document.querySelectorAll(".size-guide__content video");
  videos.forEach((video) => {
    video.setAttribute("src", video.dataset.src);
    video.play();
  });
});

const sizeGuideOverlay = document.querySelector(".size-guide__overlay");
const closeModal = () => {
  sizeGuide.classList.remove("show-modal");
  sizeGuideOverlay.classList.remove("show-overlay");
};

sizeGuideClose.addEventListener("click", closeModal);
sizeGuideOverlay.addEventListener("click", closeModal);

const sizeGuideColBtns = document.querySelectorAll(".size-guide__tab-btn");
const sizeGuideColTables = document.querySelectorAll(
  ".size-guide__sizes-cols table"
);

sizeGuideColBtns.forEach((btn) => {
  btn.addEventListener("click", function () {
    sizeGuideColBtns.forEach((btn) => btn.classList.remove("active"));
    this.classList.add("active");
    sizeGuideColTables.forEach((table) => table.classList.remove("active"));
    const matchedTable = document.querySelector(
      `#${this.dataset.table.toLowerCase()}`
    );
    matchedTable.classList.add("active");
  });
});

const sizesBtns = document.querySelectorAll(".size-guide__sizes-btn");
const sizesCards = document.querySelectorAll(".size-guide__sizes-card");

// Sizes recommendation switcher
sizesBtns.forEach((btn) => {
  btn.addEventListener("click", function () {
    const sizesLabel = this.dataset.sizes;
    const sizesCard = document.querySelector(
      `.size-guide__sizes-card[data-sizes="${sizesLabel}"]`
    );
    sizesBtns.forEach((btn) => btn.classList.remove("active"));
    sizesCards.forEach((card) => card.classList.remove("active"));
    this.classList.add("active");
    sizesCard.classList.add("active");

    renderSizesMedia(sizesCard);
  });
});

function renderSizesMedia(sizesCard) {
  if (sizesCard) {
    const sizesCardImg = sizesCard.querySelector("img");
    const sizesCardVideo = sizesCard.querySelector("video");

    if (sizesCardImg)
      sizesCardImg.setAttribute("src", sizesCardImg.dataset.src);
    if (sizesCardVideo)
      sizesCardVideo.setAttribute("src", sizesCardVideo.dataset.src);
  }
}

// Videos on media custom JS
const videosContainers = document.querySelectorAll(".custom-video-wrapper");
videosContainers.forEach((videoWrap) => {
  const playBtn = videoWrap.querySelector('.plyr__control[data-plyr="play"]');
  const previewImg = videoWrap.querySelector(".plyr__poster");
  playBtn.addEventListener("click", (e) => {
    videoWrap.setAttribute(
      "class",
      `plyr plyr--full-ui plyr--video plyr--html5 plyr--pip-supported plyr--fullscreen-enabled plyr__poster-enabled plyr--playing plyr--hide-controls plyr__tab-focus`
    );
    previewImg.classList.add("hidden");
    videoWrap.querySelector("video").play();
  });
});

document.addEventListener("product:variant-change", function (evt) {
  // Klaviyo Backinstock custom JS
  try {
    const backInStockBtn = document.querySelector(".backinstock-btn");
    if (!evt.detail.variant.available) {
      backInStockBtn.style.display = "block";
    } else {
      backInStockBtn.style.display = "none";
    }
  } catch (error) {}
});
